// extracted by mini-css-extract-plugin
export default {"container":"kQ-z","dimension":"lQ-z","dimensionLabels":"mQ-z"};